export const GET_ORDER_START = "GET_ORDER_START";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
export const GET_ORDER_FAIL = "GET_ORDER_FAIL";
export const APPROVE_ORDER = "APPROVE_ORDER";
export const EDIT_ORDER = "EDIT_ORDER";
export const CLEAR_ORDERS = "CLEAR_ORDERS";